export default __webpack_public_path__ + "static/media/rfqActive.28c70115.svg";